import { createSelector } from 'reselect';

const stepSelector = state => state.specifications.page.step;
const specificationsSelector = state => state.specifications.page.workingArea.specifications;
const isLoadingSelector = state => state.specifications.page.loading;

/* Sidebar page step data selector */
export const stepDataSelector = createSelector(
  [stepSelector],
  ({ data }) => data,
);

/* Loading selector */
export const loadingSelector = createSelector(
  [isLoadingSelector],
  (loading) => loading,
);

/* Articles selector */
export const articlesSelector = createSelector(
  [specificationsSelector],
  (specifications) => specifications.map(function (specification) {
    return specification.article;
  }),
);
